import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import KnowledgeHub from "@/pages/KnowledgeHub";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import { Toaster } from "sonner";

function removeEmergentBadge() {
  const nodes = document.querySelectorAll(
    'a[href*="emergent.sh"], a[href*="app.emergent"], [id*="emergent-badge"], [class*="emergent-badge"], a[aria-label*="Emergent" i]'
  );
  nodes.forEach((n) => {
    // skip our own scripts/links to fonts/assets — only kill UI badges
    if (n.tagName === "LINK" || n.tagName === "SCRIPT") return;
    if (n.closest("header[data-testid='site-header']") || n.closest("header[data-testid='subpage-header']")) return;
    n.style.setProperty("display", "none", "important");
    if (n.parentElement) n.remove();
  });
}

function App() {
  useEffect(() => {
    document.title = "Tradecure — Automate trading without the noise";
    removeEmergentBadge();
    const obs = new MutationObserver(() => removeEmergentBadge());
    obs.observe(document.body, { childList: true, subtree: true });
    return () => obs.disconnect();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/knowledge-hub" element={<KnowledgeHub />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
    </div>
  );
}

export default App;
